var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p-5"
};
const _hoisted_2 = { class: "columns" };
const _hoisted_3 = { class: "column is-narrow" };
const _hoisted_4 = { class: "horizontal" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h1", { class: "subtitle mb-4" }, "Partners", -1);
const _hoisted_6 = {
    key: 0,
    class: "ml-5 pb-4"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("h3", null, "Manage partners / care-providers", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
const _hoisted_9 = { class: "column is-narrow pt-3" };
const _hoisted_10 = { class: "field" };
const _hoisted_11 = { class: "control" };
const _hoisted_12 = { class: "table is-hoverable is-fullwidth" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "50%" } }, "Partner Name")
    ])
], -1);
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "No results", -1);
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { class: "horizontal" };
const _hoisted_19 = { class: "columns" };
import { useAsync } from "@/composables/useAsync";
import { useFilterForAsync } from "@/composables/useFilter";
import { Validations, useValidation } from "@/composables/useValidation";
import { doApiAction } from "@/core/api";
import { isNetworkAdmin, sessionState } from "@/core/session";
import { apiPartnerOnboarding } from "@/features/partnerOnboarding/api";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { apiPartners } from "./api";
import { Core } from "@minicity/core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerListingPanel',
    setup(__props) {
        const router = useRouter();
        const inProgressAction = ref(null);
        // Fetch caseworkers from API
        const partners = useAsync();
        onMounted(() => {
            if (sessionState.session) {
                partners.fetch(apiPartners.getForNetwork(), "Failed to load partners");
            }
        });
        // Search / category filtering
        const { searchQuery, filtered: filteredPartners } = useFilterForAsync(partners, (c) => c.name);
        // Partner invite
        const invitePartnerModalActive = ref(false);
        const { areAllFieldsValid: areAllPartnerInviteFieldsValid, validator: partnerInviteValidator } = useValidation();
        const partnerInvite = ref({
            name: "",
            isTestPartner: false
        });
        const invitePartner = () => {
            doApiAction(inProgressAction, "invitePartner", "Invite created", "Failed to create invite", () => __awaiter(this, void 0, void 0, function* () {
                yield apiPartnerOnboarding.createPartnerInvite(partnerInvite.value)
                    .then((inviteCode) => {
                    window.open(`/onboarding/partner/${encodeURIComponent(inviteCode)}`);
                    invitePartnerModalActive.value = false;
                })
                    .catch((err) => { invitePartnerModalActive.value = false; throw err; });
            }));
        };
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_LoadingTableRow = _resolveComponent("LoadingTableRow");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            const _component_OpenTasksIndicator = _resolveComponent("OpenTasksIndicator");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(isNetworkAdmin)())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _hoisted_5,
                                    (_unref(isNetworkAdmin)())
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(_component_SaveButton, {
                                                label: "Invite Partner",
                                                icon: "fa-plus",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (invitePartnerModalActive.value = true))
                                            })
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _hoisted_7
                            ]),
                            _hoisted_8,
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "input",
                                            type: "text",
                                            placeholder: "Search",
                                            autofocus: "",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(searchQuery) ? (searchQuery).value = $event : null))
                                        }, null, 512), [
                                            [_vModelText, _unref(searchQuery)]
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("table", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("tbody", null, [
                                (_unref(partners).status == 'loading')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                                        _createVNode(_component_LoadingTableRow)
                                    ]))
                                    : (_unref(filteredPartners).length == 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))
                                        : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredPartners), (partner) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: partner.id
                                    }, [
                                        _createElementVNode("td", _hoisted_18, [
                                            _createVNode(_component_PartnerBadge, {
                                                partner: partner,
                                                disabled: !partner.shown
                                            }, null, 8, ["partner", "disabled"]),
                                            _createVNode(_component_OpenTasksIndicator, {
                                                entityType: _unref(Core).EntityType['Partner'],
                                                entityId: partner.id
                                            }, null, 8, ["entityType", "entityId"])
                                        ])
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_ModalDialog, {
                    active: invitePartnerModalActive.value,
                    title: "Invite Partner",
                    "allow-close": true,
                    onClose: _cache[3] || (_cache[3] = ($event) => (invitePartnerModalActive.value = false)),
                    "first-button-text": "Go Back",
                    "first-button-severity": "link",
                    onFirstbuttonselected: _cache[4] || (_cache[4] = ($event) => (invitePartnerModalActive.value = false)),
                    "second-button-text": "Invite",
                    "second-button-severity": "primary",
                    onSecondbuttonselected: _cache[5] || (_cache[5] = ($event) => (invitePartner())),
                    loading: inProgressAction.value == 'invitePartner'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_FormTextField, {
                                    label: "Name",
                                    placeholder: "Partner / company name",
                                    modelValue: partnerInvite.value.name,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((partnerInvite.value.name) = $event)),
                                    validator: _unref(partnerInviteValidator)(_unref(Validations).notEmpty)
                                }, null, 8, ["modelValue", "validator"])
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["active", "loading"])
            ], 64));
        };
    }
});
